export const BOARD = {
    orange: {
        color: '#FFB300',
        icon: { src: '/images/block/board_orange.svg', size: 75 },
        setupIcon: { src: '/images/block/board_orange_setup.svg', size: 75 },
    },
    blue: {
        color: '#00659b',
        icon: { src: '/images/block/board_blue.svg', size: 75 },
        setupIcon: { src: '/images/block/board_blue_setup.svg', size: 75 },
    },
} as const;

export type BoardKey = keyof typeof BOARD;
